import { Head } from "@inertiajs/react"
import { useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import ContactForm from "./_form"

interface CaseRecord {
  id: number
  case_number: string
  display_name: string
}

interface ContactTypeOption {
  id: number
  name: string
}

interface ContactData {
  id: number
  contact_type_id: number | null
  category: string
  info: string
  notes: string
  sort_order: number
}

interface Props {
  case_record: CaseRecord
  contact: ContactData
  contact_types: ContactTypeOption[]
  errors?: Record<string, string[]>
}

export default function Edit({
  case_record,
  contact,
  contact_types,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Cases", href: "/cases" },
    {
      title: case_record.display_name || case_record.case_number,
      href: `/cases/${case_record.id}`,
    },
    { title: "Contacts", href: `/cases/${case_record.id}/contacts` },
    {
      title: "Edit",
      href: `/cases/${case_record.id}/contacts/${contact.id}/edit`,
    },
  ]

  const { data, setData, patch, processing, transform } = useForm({
    contact_type_id: contact.contact_type_id,
    category: contact.category,
    info: contact.info,
    notes: contact.notes,
    sort_order: contact.sort_order,
  })

  transform((data) => ({ case_contact: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    patch(`/cases/${case_record.id}/contacts/${contact.id}`)
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={`Edit Contact - ${case_record.case_number}`} />

      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">Edit Contact</h1>
        <ContactForm
          caseId={case_record.id}
          data={data}
          setData={setData}
          errors={errors}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Update Contact"
          contact_types={contact_types}
        />
      </div>
    </AppLayout>
  )
}
